import React from 'react';
import { TableRow, Button, TableCell } from '@mui/material';

// MESSAGES
import PurchaseFormattedMessages from '../../../messages/billing/PurchaseFormattedMessages';

const PurchaseTableRow = ({ element, purchase, ...props }) => (
  <TableRow id={element.tariff_line_id}>
    <TableCell>
      {element.tariff_name} for ${element.rate}
    </TableCell>
    <TableCell align="right">
      <Button
        variant="contained"
        color="secondary"
        onClick={() => purchase(element)}
      >
        {PurchaseFormattedMessages.purchase}
      </Button>
    </TableCell>
  </TableRow>
);

export default PurchaseTableRow;
